<template>
  <div class="graduationAE">
    <div class="cont-box">
      <div class="classTitle">
        <Title text="任务开题" />
      </div>
      <!-- <div>
        <el-form
              ref="search"
              :inline="true"
              :model="condition"
              :rules="searchRules"
              class="search-form"
              slot="search"
              label-width="80px"
          >
              <div style="display: flex; justify-content: space-between">
                  <div>

                  </div>
                  <div>
                    <div class="btn-box">
                      <div>
                        <el-form-item>
                          <el-button type="primary" @click="openingReportClick('phaseOne')">任务书及开题报告上传</el-button>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
              </div>
          </el-form>
      </div> -->
      <div class="graduation-tab">
        <el-table
            :data="list"
            headerRowClassName="uni-primary-table-header"
            stripe
            border
          >
            <el-table-column prop="paper_plan_title" align="center" label="计划" min-width="120"></el-table-column>
            <el-table-column prop="" align="center" label="专业任务书" min-width="120">
                <template slot-scope="{ row }">
                    <el-button class="link-btn" type="text" @click="taskTitleClick(row)">下载任务书</el-button>
                </template>
            </el-table-column>
<!--            <el-table-column prop="is_degree" align="center" label="是否需要学位">-->
<!--              <template slot-scope="{ row }">-->
<!--                <span>{{ row.is_degree == 1 ? '是' : '否' }}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="is_degree" align="center" label="英语合格证照片">-->
<!--              <template slot-scope="{ row }">-->
<!--                <el-image-->
<!--                    v-if="row.score_imgs_url ? true : false"-->
<!--                    class="see-img"-->
<!--                    :src="row.score_imgs_url.split(',')[0]"-->
<!--                    fit="contain"-->
<!--                    :preview-src-list="[row.score_imgs_url.split(',')[0]]"-->
<!--                ></el-image>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="is_degree" align="center" label="计算机合格证照片">-->
<!--              <template slot-scope="{ row }">-->
<!--                <el-image-->
<!--                    v-if="row.score_imgs_url ? true : false"-->
<!--                    class="see-img"-->
<!--                    :src="row.score_imgs_url.split(',')[1]"-->
<!--                    fit="contain"-->
<!--                    :preview-src-list="[row.score_imgs_url.split(',')[1]]"-->
<!--                ></el-image>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="is_degree" align="center" label="成绩单照片">-->
<!--              <template slot-scope="{ row }">-->
<!--                <el-image-->
<!--                    v-if="row.score_imgs_url ? true : false"-->
<!--                    class="see-img"-->
<!--                    :src="row.score_imgs_url.split(',')[2]"-->
<!--                    fit="contain"-->
<!--                    :preview-src-list="[row.score_imgs_url.split(',')[2]]"-->
<!--                ></el-image>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="teacher_title" align="center" label="指导老师"></el-table-column>
            <!-- <el-table-column prop="start_year" align="center" label="年份"></el-table-column> -->
            <el-table-column prop="teacher_mobile" align="center" label="联系电话"></el-table-column>
            <!-- <el-table-column prop="end_upload_time" align="center" label="任务及开题截止时间"></el-table-column> -->
            <!-- <el-table-column prop="end_apply_time" align="center" label="答辩申请截止时间"></el-table-column> -->
<!--            <el-table-column prop="" align="center" label="答辩日期">-->
<!--              <template slot-scope="{ row }">-->
<!--                <span>{{ row.defense_start_at }} - {{ row.defense_end_at }}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="score_apply_time" align="center" label="交稿截止时间"></el-table-column>
            <!-- <el-table-column prop="process_status_title" align="center" label="流程状态"></el-table-column> -->
            <!-- <el-table-column align="center" label="操作" width="200">
              <template slot-scope="{row}">
                <el-button type="text" @click="openingReportClick(row)">任务书及开题报告上传</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
      <!-- 查看任务书 -->
      <el-dialog
          title="查看任务书"
          :visible.sync="isShowAssignmentLook"
          width="30%"
          @close="assignmentLookClose"
      >
          <div class="dialog" >
              <div v-for="(item, index) in assignmentList" :key="index">
                  <span>{{ item.name }}</span>
                  <el-button
                      type="text"
                      style="margin-left: 10px;"
                      @click="downloadAssignment(item)"
                  >下载</el-button>
              </div>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="isShowAssignmentLook = false">取 消</el-button>
          </div>
      </el-dialog>
      <!-- 上传任务书及开题报告/上传资料 -->
      <el-dialog
        class="openingReport"
        title="任务书及开题报告上传"
        :visible.sync="isShowOpeningReport"
        width="40%"
        @close="openingReportClose"
      >
        <div class="dialog" >
          <el-form
            ref="openingReport"
            :model="openingReportData"
            :rules="openingReportRules"
            label-width="200px"
          >
            <el-form-item label="设计资料文件:" prop="files_url">
              <FalConUpload
                ref="uploadFile"
                listStyle='text'
                accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
              >
              </FalConUpload>
              <div class="tips">说明：可上传PDF文档，压缩文件或OFFICE文档</div>
            </el-form-item>
            <!-- <el-form-item label="设计资料图片" prop="imgs_url">
              <FalConUpload
                ref="uploadPaperPictures"
                :multiple="true"
                :limit="20"
                :isShowModal="false"
                @handleRemove="paperPicturesHandleRemove"
                @handleChange="paperPicturesHandleChange"
              ></FalConUpload>
            </el-form-item> -->
            <el-form-item label="手写签名:" prop="sign_img">
              <esignHandle
                ref="esignHandle"
                :selectSignImg.sync="openingReportData.sign_img"
              ></esignHandle>
            </el-form-item>
            <el-form-item label="是否需要取得学位:" prop="is_degree">
              <el-radio-group v-model="openingReportData.is_degree" size="small" fill="#67C23A" label="size control">
                  <el-radio-button :label="1">是</el-radio-button>
                  <el-radio-button :label="0">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div v-if="openingReportData.is_degree == 1">
              <el-form-item label="英语合格证照片" prop="img1">
                <FalConUpload
                  ref="uploadimg1"
                  :isShowModal="false"
                  @handleRemove="img1HandleRemove"
                  @handleChange="img1HandleChange"
                ></FalConUpload>
              </el-form-item>
              <el-form-item label="计算机合格证照片" prop="img2">
                <FalConUpload
                  ref="uploadimg2"
                  :isShowModal="false"
                  @handleRemove="img2HandleRemove"
                  @handleChange="img2HandleChange"
                ></FalConUpload>
              </el-form-item>
              <el-form-item label="成绩单照片" prop="img3">
                <FalConUpload
                  ref="uploadimg3"
                  :isShowModal="false"
                  @handleRemove="img3HandleRemove"
                  @handleChange="img3HandleChange"
                ></FalConUpload>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button @click="isShowOpeningReport = false">取 消</el-button>
          <el-button type="primary" @click="openingReportSubmit">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { getPaperApi } from "@/api/basic";

import {downladUrl} from '@/utils/func';

import { putObject, uploadFiles, deleteObject } from "@/utils/upload";
import FalConUpload from "@/components/uploadFile";
import esignHandle from '@/components/esignHandle';

import {deepClone} from '@/utils/func';

import {
  adultStudentPpsUpReport,
} from "@/api/graduation";

export default {
  name: "graduationAE",
  components: { FalConUpload, esignHandle },
  data() {
    return {
      entranceType:"",
      list:[],
      listTotal: -1,
      // 查看任务书
      isShowAssignmentLook: false,
      assignmentList: [],

      // 任务书及开题报告/设计资料文件
      isShowOpeningReport: false,
      openingReportData: {
        paper_plan_student_id: '',  //论文计划学生id
        files_url: '',  //任务书及开题报告文件/设计资料文件
        // imgs_url: '',  //任务书及开题报告图片/设计资料图片
        score_imgs_url: '',  //英语合格证照片 + 计算机合格证照片 + 成绩单照片
        img1: '',  //英语合格证照片
        img2: '',  //计算机合格证照片
        img3: '',  //成绩单照片
        sign_img: '',  //手写签名图片地址
        is_degree: 0,  //是否需要取得学位
      },
      openingReportRules: {
        files_url: [{ required: true, message: '请上传设计资料文件', trigger: 'change' }],
        // imgs_url: [{ required: true, message: '请上传设计资料图片', trigger: 'change' }],
        sign_img: [{ required: true, message: '请添加手写签名', trigger: 'change' }],
        is_degree: [{ required: true, message: '请选择是否需要取得学位', trigger: 'change' }],
        // img1: [{ required: true, message: '请上传英语合格证照片', trigger: 'change' }],
        // img2: [{ required: true, message: '请上传计算机合格证照片', trigger: 'change' }],
        // img3: [{ required: true, message: '请上传成绩单照片', trigger: 'change' }],
      },
    };
  },
  filters:{
    status(val){
      if(val==0){
        return '待审核';
      }else if(val==1){
        return '已通过';
      }else{
        return '待调整';
      }
    }
  },
  created() {
    this.getListFn();
  },
  methods: {
    // 弹窗 任务书及开题报告上传/设计(论文)上传 提交
    openingReportSubmit(){
      this.$refs["openingReport"].validate(async (valid) => {
        if (valid) {
          uploadFiles(this.openingReportData.files_url, async (urls) => {
            let data = deepClone(this.openingReportData);
            let params = {
              paper_plan_student_id: data.paper_plan_student_id,
              files_url: urls,
              score_imgs_url: data.is_degree == 1 ? (data.img1 + ',' + data.img2 + ',' + data.img3) : '',
              sign_img: data.sign_img,
              is_degree: data.is_degree,
            };
            adultStudentPpsUpReport(params).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功');
                this.isShowOpeningReport = false;
                this.getListFn();
              }
            });
          }, null, 'student', '', true);
        }
      })
    },
    // 弹窗 任务书及开题报告/设计资料 关闭
    openingReportClose(){
      this.openingReportData = {
        paper_plan_student_id: '',  //论文计划学生id
        files_url: '',  //任务书及开题报告文件/设计资料文件
        // imgs_url: '',  //任务书及开题报告图片/设计资料图片
        score_imgs_url: '',  //英语合格证照片 + 计算机合格证照片 + 成绩单照片
        img1: '',  //英语合格证照片
        img2: '',  //计算机合格证照片
        img3: '',  //成绩单照片
        sign_img: '',  //手写签名图片地址
        is_degree: 0,  //是否需要取得学位
      };
      this.$refs['uploadFile'].reset();
      // this.$refs['uploadPaperPictures'].reset();
      if(this.openingReportData.is_degree == 1){
        this.$refs['uploadimg1'].reset();
        this.$refs['uploadimg2'].reset();
        this.$refs['uploadimg3'].reset();
      }
      this.$refs['esignHandle'].handleReset();  //签名这块清空
      this.$nextTick(() => {
        this.$refs['openingReport'].clearValidate();
      });
    },
    // 任务书及开题报告/设计资料 图片 删除
    // paperPicturesHandleRemove(data){
    //   let fileName = data.file.name;
    //   let filesUrlArr = JSON.parse(this.openingReportData.imgs_url);
    //   this.openingReportData.imgs_url = arrAttDel(filesUrlArr, 'name', fileName, 'json');
    // },
    // 任务书及开题报告图片  多传
    // paperPicturesHandleChange(val){
    //   uploadFiles(val.fileList, (urls) => {
    //     this.openingReportData.imgs_url = urls;
    //   }, null, 'student', '', true);
    // },
    // 上传 英语合格证照片
    img1HandleChange(val){
      putObject(val.file, (urls) => {
        this.openingReportData.img1 = urls;
      }, null, 'student', '', false);
    },
    // 上传 英语合格证照片 删除
    img1HandleRemove(data){
      this.openingReportData.img1 = '';
    },
    // 上传 计算机合格证照片
    img2HandleChange(val){
      putObject(val.file, (urls) => {
        this.openingReportData.img2 = urls;
      }, null, 'student', '', false);
    },
    // 上传 计算机合格证照片 删除
    img2HandleRemove(data){
      this.openingReportData.img2 = '';
    },
    // 上传 成绩单照片
    img3HandleChange(val){
      putObject(val.file, (urls) => {
        this.openingReportData.img3 = urls;
      }, null, 'student', '', false);
    },
    // 上传 成绩单照片 删除
    img3HandleRemove(data){
      this.openingReportData.img3 = '';
    },
    // 上传 任务书及开题报告文件/设计资料文件
    handleChangeFile(data) {
      this.openingReportData.files_url = data.fileList;
      // uploadFiles(data.fileList, (urls) => {
      //   this.openingReportData.files_url = urls;
      // }, null, 'student', '', true);
    },
    //  删除 任务书及开题报告文件/设计资料文件
    handleRemoveFile(data) {
      this.openingReportData.files_url = data.fileList;
      // let fileName = data.file.name;
      // let filesUrlArr = JSON.parse(this.openingReportData.files_url);
      // this.openingReportData.files_url = arrAttDel(filesUrlArr, 'name', fileName, 'json');
    },
    // 点击 任务书及开题报告/设计资料
    openingReportClick(row){
      this.openingReportData.paper_plan_student_id = row.id;
      this.isShowOpeningReport = true;
    },
    // 弹窗 查看任务书 下载
    downloadAssignment(row){
      downladUrl(row.url, row.name);
    },
    // 弹窗 查看任务书 关闭
    assignmentLookClose(){
        this.assignmentList = [];
    },
    // 点击任务书查看文件 查看任务书
    taskTitleClick(row){
        this.assignmentList = JSON.parse(row.files_url);
        this.isShowAssignmentLook = true;
    },
    // 点击 上传资料
    // viewOpeningReport(row){
    //   this.$router.push({
    //     name: "viewOpeningReportAE",
    //     query: {
    //       id: row.id,
    //       process_status: row.process_status,
    //       end_propose_time: row.end_propose_time,
    //       end_at: row.end_at
    //     },
    //   });
    // },
    // 获取数据
    async getListFn(){
      const {code,result,msg} = await getPaperApi();
      if(code != 200)return
      this.list = result
    },
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss" scoped>
.graduationAE {
  min-height: $contentH;
	padding: $sideMargin;
	padding-bottom: 0;
  .cont-box{
    background: $white;
    min-height: inherit;
    padding: 0 20px 20px;
  }
}
.see-img{
        width: 50px;
    }
</style>
